import { render, staticRenderFns } from "./SliderBoxplotGraph.vue?vue&type=template&id=f0023d30"
import script from "./SliderBoxplotGraph.vue?vue&type=script&lang=js"
export * from "./SliderBoxplotGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports